import React from 'react';
import FrontHeader from '../components/common/FrontHeader';
import FrontFooter from '../components/common/FrontFooter';
import './LegalPages.css';

const Security = () => {
  return (
    <div className="legal-page">
      <FrontHeader />
      <div className="legal-container">
        <h1>Security</h1>
        <p className="subtitle">How we protect your data and transactions</p>

        <section>
          <h2>Encryption</h2>
          <p>All data transmitted between your browser and our servers is encrypted using TLS 1.3 (Transport Layer Security). Sensitive information such as passwords and payment details are additionally hashed or encrypted at rest.</p>
        </section>

        <section>
          <h2>Secure Escrow</h2>
          <p>SeaZex partners with regulated financial institutions to hold funds in escrow. Money is only released after mutual agreement or dispute resolution, ensuring both parties are protected.</p>
        </section>

        <section>
          <h2>Authentication</h2>
          <p>We support strong password policies and recommend using a unique, complex password. Two-factor authentication (2FA) is available for added security on your account settings.</p>
        </section>

        <section>
          <h2>Data Protection</h2>
          <p>We follow industry best practices for data protection, including regular security audits, access controls, and monitoring for suspicious activity. Only authorized personnel have access to user data.</p>
        </section>

        <section>
          <h2>Vendor Verification</h2>
          <p>All service providers undergo a verification process where we review their trade licenses, certifications, and insurance. Verified badges help owners identify trustworthy partners.</p>
        </section>

        <section>
          <h2>Reporting Vulnerabilities</h2>
          <p>If you discover a security vulnerability, please report it to security@seazex.com. We will investigate and address issues promptly.</p>
        </section>

        <section>
          <h2>Your Responsibility</h2>
          <p>Keep your account credentials confidential. Log out after each session, especially on shared devices. Enable 2FA for additional protection.</p>
        </section>

        <div className="security-badge">
          <i className="fas fa-shield-alt"></i>
          <span>PCI DSS Compliant</span>
          <i className="fas fa-lock"></i>
          <span>GDPR Ready</span>
          <i className="fas fa-check-circle"></i>
          <span>ISO 27001 Certified</span>
        </div>
      </div>
      <FrontFooter />
    </div>
  );
};

export default Security;